<script lang="ts">
	//Hooks
	import { beforeUpdate } from 'svelte';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
import { devices } from 'src/stores/lists/devices';
	//Services
	import { localReq, postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Configs
	import { devices_config } from '@devices/index';
	//Design system components
	import { Button, Input, Text, toast } from '@Shelly/shelly-design-system';
	import SyncName from '../../ApplicationSettings/SyncName.svelte';
	import { NO_CHANNELS_GEN_1_DEVICES, ONE_CHANNEL_GEN_1_DEVICES } from 'src/constants';

	export let device;

	$: isOneChanDev =
		NO_CHANNELS_GEN_1_DEVICES.includes(device.type) ||
		(device.type === 'SHRGBW2' && $settingsStore?.device?.mode === 'color');

	const id = real_id(device.id);

	let localIp = get_local_ip(id);

	$: synced = device.name_sync;

	let channelsCount, mode;

	let loading = false;

	$: statusStore = getDeviceStatus(id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;

	let name =
		device.channels_count < 2
			? $devices[device.id].name
			: $settingsStore.name
				? $settingsStore.name
				: device.name;

	$: error = name === '' && device.name_sync;
	let cache = name;

	beforeUpdate(() => {
		// device = {id: data.id, category:devices_config[data.type].family, channel:0, gen:data.gen};
		if (
			status?.online &&
			typeof settings !== 'undefined' &&
			typeof devices_config[device.type] !== 'undefined'
		) {
			mode =
				typeof status.mode !== 'undefined'
					? status.mode
					: settings.mode && settings.mode !== '_unknown_'
						? settings.mode
						: devices_config[device.type].family
							? devices_config[device.type].family
							: '';

			channelsCount = devices_config[$devices[device.id].type].modes[mode]?.channels;
		}
	});

	const changeName = async () => {
		let res;
		name = name.trim();
		if (cache !== name && name !== '') {
			loading = true;
			if (synced) {
				if (localIp) {
					// save to local ui
					// if (name.length < 1) name = 'null'; //doing this, to handle some kind of delete name if needed revert it
					res = await localReq(device, `${localIp}/settings`, 'post', {
						name,
					});
				} else {
					res = await postReq(`/device/rename`, {
						id: id,
						name: name.length > 0 ? name : 'null',
					});
				}
			}

			cache = name;
			device.name = name;
			let int_res = await postReq('interface/device/save', {
				id: device.id,
				data: JSON.stringify(device),
			});
			if (int_res.isok) {
				settings.name = name;
				devices_settings.update_devices_settings(id, settings);
				toast.open({
					type: 'success',
					title:
						$format('chan_name_succ', { values: { name: name } }) ||
						`Channel name was changed to ${name}`,
				});
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
			}
		}
		loading = false;
	};
</script>

<Input
	icon="fas fa-microchip"
	class="mb-s"
	size="m"
	bind:value={name}
	label={$format('sub_settings_title_device_name')}
	error={error ? $format('input_error_empty_name', { default: 'Name cannot be empty' }) : ''}
	on:enter={changeName}
	id="input-cqx011b"
	aria-labelledby="input-cqx011b"
/>

{#if (device.channels_count === 1 && (isOneChanDev || ONE_CHANNEL_GEN_1_DEVICES.includes(device.type))) || (device.type === 'SHSW-25' && device.category === 'roller')}
	<SyncName
		nameType="device"
		{device}
		info={$format('device_rename_description', {
			default:
				'Keep the device name in sync with the name given in the application. The sync is only from the application to the device and not vice-versa.',
		})}
	/>
{:else}
	<Text class="mt-s mb-s" styleType="body-small">
		{$format('device_rename_description_in_settings', {
			default:
				'Change the current device name. This will reflect on the device name in the settings.',
		})}
	</Text>
{/if}

<Button
	{loading}
	disabled={error || cache === name}
	size="m"
	class="mt-s"
	width="full"
	on:click={changeName}
>
	{$format('button_save')}
</Button>
